import React from 'react';
import { makeHtml } from '../../services/cms/markdownConverter';
import './HtmlText.scss';

const HtmlText = ({ content }) => {
    let htmlContent = makeHtml(content);
    return (
        <div
            className='htmlText'
            dangerouslySetInnerHTML={{ __html: htmlContent }}></div>
    );
};

export default HtmlText;
